import React, { useState, useContext, useEffect } from 'react';
import { Alert } from 'components';
import { I18nContext } from 'i18n';
import styled, { css } from 'styled-components';

const ErrorMessage = () => {
  const [show, setShow] = useState(true);
  const [hide, setHide] = useState(false);
  const { translate } = useContext(I18nContext);

  useEffect(() => {
    if(hide) {
      setTimeout(() => {
        setShow(false);
      }, 1000);
    }
  }, [hide])

  return (
    <>
      {show && (
        <StyledError hide={hide}>
          <Alert onClose={() => setHide(true)} dismissible variant="danger">
            <Heading>{translate('error_header')}</Heading>
            <Body>{translate('error_body')}</Body>
          </Alert>
        </StyledError>
      )}
    </>
  );
};

const Heading = styled.h4`
  font-size: 1.3rem;
`;

const Body = styled.span`
  font-size: 0.9rem;
`;

const StyledError = styled.div`
  position: fixed;
  bottom: 0.5rem;
  z-index: 9999;
  left: 50%;
  width: 26rem;
  margin-left: -13rem;
  transition: all 1s ease 0s;


  ${({hide}) =>
    hide &&
    css`
      bottom: -10rem;
    `}
`;

export default ErrorMessage;
